import './LegalPage.css';

function TermsPage() {
    return (
        <div className="Legal-content">
            <div className="glass-card legal-card">
                <h1 className="legal-title">Terms of Service</h1>
                
                <div className="legal-text">
                    <p className="last-updated">Effective Date: July 25, 2025</p>
                    
                    <p>Welcome to Geomatchry ("we," "us," or "our"). These Terms of Service ("Terms") govern your use of our dating application (the "App") and related services. By creating an account or using our App, you agree to these Terms.</p>
                    
                    <h2>1. Acceptance of Terms</h2>
                    <p>By accessing or using our App, you agree to be bound by these Terms and our Privacy Policy. If you do not agree to these Terms, do not use our App.</p>
                    
                    <h2>2. Eligibility</h2>
                    <p>You must be at least 18 years old to use our App. By using the App, you represent and warrant that:</p>
                    <ul>
                        <li>You are at least 18 years of age</li>
                        <li>You are legally capable of entering into binding contracts</li>
                        <li>You are located in the United States</li>
                        <li>You have not been previously banned from using our services</li>
                    </ul>
                    
                    <h2>3. Account Registration</h2>
                    
                    <h3>3.1 Account Creation</h3>
                    <p>To use our App, you must create an account using a valid email address. You agree to provide accurate and complete information during registration.</p>
                    
                    <h3>3.2 Account Security</h3>
                    <p>You are responsible for maintaining the confidentiality of your account credentials and for all activities that occur under your account. Notify us immediately of any unauthorized use.</p>
                    
                    <h3>3.3 Account Deletion</h3>
                    <p>You may delete your account at any time through the App settings. Upon deletion, we will remove your profile, messages, markers, photos (including Live Marker photos), and all associated data from our systems.</p>
                    
                    <h2>4. User Conduct</h2>
                    
                    <h3>4.1 Acceptable Use</h3>
                    <p>You agree to use the App in a lawful manner and to treat other users with respect. You must not:</p>
                    <ul>
                        <li>Provide false or misleading information</li>
                        <li>Impersonate any person or entity</li>
                        <li>Harass, abuse, or harm other users</li>
                        <li>Post inappropriate, offensive, or sexually explicit content in profiles, Live Marker photos, or messages</li>
                        <li>Use the App for commercial solicitation</li>
                        <li>Attempt to access other users' accounts</li>
                        <li>Use Live Marker photos to misrepresent your current location or appearance</li>
                        <li>Violate any applicable laws or regulations</li>
                    </ul>
                    
                    <h3>4.2 Profile Content</h3>
                    <p>Your profile photo should be of yourself, and your bio information should be accurate. Live Marker photos must be taken in real-time and should follow the same content guidelines as profile photos. We reserve the right to remove content that violates these Terms.</p>
                    
                    <h2>5. Location Services</h2>
                    
                    <h3>5.1 Marker Feature</h3>
                    <p>Our App's core functionality relies on location services. When you place a marker, other users who place markers within your selected distance and time parameters can see your profile. However, users cannot see your exact location, specific distance, or any precise location data - they only know that you placed a marker within their specified search parameters.</p>
                    
                    <h3>5.2 Live Markers</h3>
                    <p>When placing a marker, you may use the "Live Markers" feature to take a real-time photo that other users will see alongside or instead of your profile photo. These photos must be taken at the time of marker placement and are subject to our content guidelines.</p>
                    
                    <h3>5.3 Marker Deletion</h3>
                    <p>You may delete your markers at any time. Deleting a marker will remove your visibility for that marker, including any associated Live Marker photos.</p>
                    
                    <h3>5.4 Location Permissions</h3>
                    <p>Location access is required to place markers and discover other users. You may control location permissions through your device settings, but this will limit App functionality.</p>
                    
                    <h2>6. Matching and Messaging</h2>
                    
                    <h3>6.1 Mutual Consent</h3>
                    <p>Users can only exchange messages after both parties have "liked" each other, creating a mutual match.</p>
                    
                    <h3>6.2 Message Content</h3>
                    <p>You are solely responsible for your message content. Do not send inappropriate, threatening, or illegal content.</p>
                    
                    <h3>6.3 No Encryption</h3>
                    <p>Messages are not end-to-end encrypted and may be accessed by us for safety, legal, and service improvement purposes.</p>
                    
                    <h2>7. Safety and Reporting</h2>
                    
                    <h3>7.1 User Safety</h3>
                    <p>While we strive to create a safe environment, we cannot guarantee the conduct of users. Exercise caution when interacting with others, especially when meeting in person.</p>
                    
                    <h3>7.2 Reporting</h3>
                    <p>You may report users who violate these Terms through our in-app reporting feature. We commit to reviewing reports within 24 hours.</p>
                    
                    <h3>7.3 Blocking</h3>
                    <p>You may block other users at any time to prevent further interaction.</p>
                    
                    <h2>8. Content Rights</h2>
                    
                    <h3>8.1 Your Content</h3>
                    <p>You retain ownership of the content you upload, including profile photos and Live Marker photos. By using our App, you grant us a worldwide, non-exclusive, royalty-free license to use, display, and distribute your content as necessary to provide our services.</p>
                    
                    <h3>8.2 Other Users' Content</h3>
                    <p>You may not copy, modify, or distribute other users' content without their permission.</p>
                    
                    <h2>9. Privacy and Data</h2>
                    <p>Your use of our App is subject to our Privacy Policy. We use Google Firebase for backend services and data storage. We collect and process your data in accordance with applicable privacy laws.</p>
                    
                    <h2>10. Disclaimers</h2>
                    
                    <h3>10.1 Service Availability</h3>
                    <p>We strive to maintain reliable service but cannot guarantee uninterrupted access. The App is provided "as is" without warranties of any kind.</p>
                    
                    <h3>10.2 User Interactions</h3>
                    <p>We are not responsible for users' offline behavior or interactions. We do not conduct background checks on users.</p>
                    
                    <h3>10.3 Third-Party Services</h3>
                    <p>Our App may integrate with third-party services. We are not responsible for third-party content or services.</p>
                    
                    <h2>11. Limitation of Liability</h2>
                    <p>To the maximum extent permitted by law, we shall not be liable for any indirect, incidental, special, consequential, or punitive damages arising from your use of the App.</p>
                    
                    <h2>12. Indemnification</h2>
                    <p>You agree to indemnify and hold us harmless from any claims, damages, or expenses arising from your violation of these Terms or your use of the App.</p>
                    
                    <h2>13. Termination</h2>
                    <p>We reserve the right to suspend or terminate your account at any time for violation of these Terms or for any other reason at our sole discretion.</p>
                    
                    <h2>14. Changes to Terms</h2>
                    <p>We may update these Terms from time to time. We will notify you of material changes through the App or via email. Continued use after changes constitutes acceptance.</p>
                    
                    <h2>15. Governing Law</h2>
                    <p>These Terms are governed by the laws of Massachusetts, United States, without regard to conflict of law principles.</p>
                    
                    <h2>16. Dispute Resolution</h2>
                    <p>Any disputes arising from these Terms or your use of the App shall be resolved through binding arbitration in accordance with the rules of the American Arbitration Association.</p>
                    
                    <h2>17. General Provisions</h2>
                    
                    <h3>17.1 Entire Agreement</h3>
                    <p>These Terms constitute the entire agreement between you and us regarding the use of our App.</p>
                    
                    <h3>17.2 Severability</h3>
                    <p>If any provision of these Terms is found to be unenforceable, the remaining provisions shall continue in effect.</p>
                    
                    <h3>17.3 No Waiver</h3>
                    <p>Our failure to enforce any provision of these Terms shall not constitute a waiver of that provision.</p>
                    
                    <h2>18. Contact Information</h2>
                    <p>If you have any questions about these Terms, please contact us at: <a href="mailto:support@geomatchry.com">support@geomatchry.com</a></p>
                    
                    <p className="acknowledgment"><strong>By using Geomatchry, you acknowledge that you have read, understood, and agree to be bound by these Terms of Service.</strong></p>
                </div>
            </div>
        </div>
    );
}

export default TermsPage;